import { render, staticRenderFns } from "./RefundIcon.vue?vue&type=template&id=479658c6&scoped=true&"
import script from "./RefundIcon.vue?vue&type=script&lang=js&"
export * from "./RefundIcon.vue?vue&type=script&lang=js&"
import style0 from "./RefundIcon.vue?vue&type=style&index=0&id=479658c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479658c6",
  null
  
)

export default component.exports